/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTwitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M14.615 2.622a5.23 5.23 0 015.46 1.088c.885-.31 1.724-.743 2.493-1.285a.75.75 0 011.16.79 8.47 8.47 0 01-2.011 3.748c.021.19.032.381.033.573v.002c0 6.013-2.89 10.4-7.023 12.6-4.114 2.19-9.384 2.171-14.091-.444a.75.75 0 01.394-1.405 10.89 10.89 0 005.411-1.196c-2.536-1.442-3.908-3.342-4.565-5.289-.748-2.213-.544-4.41-.22-5.923.138-.64.3-1.17.427-1.542a10.046 10.046 0 01.21-.556l.015-.034.004-.01.002-.003v-.001L3 4.038l-.685-.304a.75.75 0 011.299-.127 9.91 9.91 0 007.636 4.204v-.238a5.23 5.23 0 013.365-4.951zM3.273 5.578c-.051.189-.102.395-.15.617-.294 1.374-.454 3.27.174 5.13.617 1.828 2.02 3.7 5.008 5.028a.75.75 0 01.116 1.306A12.39 12.39 0 014 19.535c3.519 1.147 7.12.824 10.024-.721 3.617-1.926 6.227-5.788 6.227-11.274 0-.232-.023-.463-.067-.69a.75.75 0 01.21-.676 6.965 6.965 0 001.11-1.421c-.463.208-.94.387-1.427.533a.75.75 0 01-.782-.226 3.73 3.73 0 00-6.544 2.498v1.01a.75.75 0 01-.73.75 11.41 11.41 0 01-8.747-3.74zm.413-1.236z'
      />
    </svg>
  );
}

export default SvgTwitter;
